import { createSlice } from '@reduxjs/toolkit';
import { initFileData, initModal, initSideModal } from 'helpers/utils';
import { IInitFile, IInitModal, IInitSideModal } from 'helpers/types';
import { Dispatch } from 'redux';

interface IModalType {
  modal: IInitModal;
  sideModal: IInitSideModal;
  fileData: IInitFile;
}

const initialState: IModalType = {
  modal: initModal,
  sideModal: initSideModal,
  fileData: initFileData,
};

const modalSlice = createSlice({
  name: 'Modal',
  initialState: initialState,
  reducers: {
    setModal: (state, { payload }: { payload: IInitModal }) => {
      state.modal = payload;
    },
    setSideModal: (state, { payload }: { payload: IInitSideModal }) => {
      state.sideModal = payload;
    },
    setFileData: (state, { payload }: { payload: IInitFile }) => {
      state.fileData = payload;
    },
  },
});

export const setSideModalData = (payload: IInitSideModal) => async (dispatch: Dispatch) => {
  try {
    dispatch(setSideModal(payload));
  } catch (error) {
    return Promise.reject(error);
  }
};
export const setPreviewFileData = (payload: IInitFile) => async (dispatch: Dispatch) => {
  try {
    dispatch(setFileData(payload));
  } catch (error) {
    return Promise.reject(error);
  }
};

export const { setModal, setSideModal, setFileData } = modalSlice.actions;
export default modalSlice.reducer;
